import { useEffect, useState, useCallback } from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import SearchBox from "../../core/SearchBox/SearchBox";
import FeedItem from "../../content/Feed/Post/FeedItem";
import postItemService from "../../../Axios/services/postItem.service";
import { PostItem } from "../../../../../entities/build/src/Content";
import { FeedEventItem } from "../../content/Feed/FeedEventItem/FeedEventItem";
import { removeDuplicateEvents } from "../../../helpers/helpers";
import "../../../App.scss";

const MyFeed = () => {
  const navigate = useNavigate();
  const { me } = useSelector((state: any) => state.auth);
  const [filteredPosts, setFilteredPosts] = useState<PostItem[]>([]);
  const [posts, setPosts] = useState<PostItem[] | undefined>(undefined);
  const [searchInput, setSearchInput] = useState("");
  
  const fetchPosts = useCallback(async () => {
    if (me?._id) {
      const _posts = await postItemService.getAll(me._id);
      const activePosts = [..._posts].filter((post: any) => post.content.status === "Active" || post.content.status === null);
      const p = removeDuplicateEvents(activePosts);
      setPosts(p);
      setFilteredPosts(p);
    }
  }, [setPosts, setFilteredPosts, me]);
  
  useEffect(() => {
    fetchPosts();
  }, [fetchPosts]);
  
    const onEnter = (e: any) => {
      navigate("/search/" + searchInput);
    };

    const searchHandler = (event: any) => {
      setSearchInput(event.target.value);
    };

  return (
    <div className="container-fluid px-md-1 px-0">
      {posts && posts.length > 0 && (
        <div className="mx-md-0 mb-4 px-md-0 px-3">
          <SearchBox placeholder={"Find event, member, post or hashtag..."} changeHandler={searchHandler} onEnter={onEnter} value={searchInput} />
        </div>
      )}

      {posts ? (
        posts.length > 0 ? (
          filteredPosts.map((post: any) => {
            if (post?.eventContentItem) {
              return (
                <div key={post._id}>
                  <FeedEventItem item={post} />
                </div>
              );
            } else if (post?.sessionContentItem) {
              return <div key={post._id}></div>;
            } else {
              return (
                <div key={post._id}>
                  <FeedItem item={post} />
                </div>
              );
            }
          })
        ) : (
          <div className="row my-5">
            <div className="col-12">No posts to show, maybe your communities don't have any posts yet.</div>
          </div>
        )
      ) : (
        Array.from(Array(4).keys()).map((_, i) => (
          <div className="feed-item py-3 px-5" key={i}>
            <SkeletonTheme>
              <div className="row flex-wrap">
                <div className="col-2 d-flex justify-content-center">
                  <Skeleton circle={true} height={60} width={60} />
                </div>
                <div className="col-10">
                  <p className="m-0 p-0">
                    <Skeleton height={10} width={150} />
                  </p>
                  <p className="m-0 p-0">
                    <Skeleton height={10} width={180} />
                  </p>
                  <p className="m-0 p-0">
                    <Skeleton height={10} width={80} />
                  </p>
                </div>
              </div>
            </SkeletonTheme>
          </div>
        ))
      )}
      <div className="space"></div>
    </div>
  );
};

export default MyFeed;
